import type { SoldInventoryItem } from '@cuito/types';

interface Props {
  items: SoldInventoryItem[];
  loading: boolean;
  error: string | null;
}

/**
 * 售出库存 tab（契约 §13.4；UI 规范 §3.2 的同名 tab 行）。
 *
 * `netQty` 取服务端值（§13.4 的对账口径 `grossQty − refundedQty`），前端不重算 ——
 * 重算出来的数与「售出库存」这个对账口径会在退款并发时静默分叉。
 */
export default function SoldInventoryTab({ items, loading, error }: Props) {
  if (loading) return <p className="py-8 text-center text-gray-500">加载中…</p>;
  if (error !== null) {
    return (
      <p className="font-bold text-red-600" data-testid="sold-inventory-error">
        {error}
      </p>
    );
  }
  if (items.length === 0) return <p className="text-gray-500">暂无售出库存记录</p>;

  return (
    <ul className="flex flex-col gap-2">
      {items.map((item) => (
        <li
          key={item.productId}
          className="flex items-center justify-between rounded-lg border-2 border-black p-3"
          data-testid="sold-inventory-row"
          data-product-name={item.productName}
        >
          <span className="font-bold">{item.productName}</span>
          <span className="text-gray-600">
            净 {item.netQty} 件（售出 {item.grossQty} 件 · 已退 {item.refundedQty} 件）
          </span>
        </li>
      ))}
    </ul>
  );
}
